import type { CaseDetail } from '../portfolio';

const hitachiSolutionsCase: CaseDetail = {
  id: 'hitachi-solutions',
  project: 'Hitachi Solutions Create',
  client: 'Hitachi Solutions',
  year: 'Archive',
  category: 'Recruitment Branding / Web',
  role: 'Brand Strategy / Web / Communication',
  issue: 'IT企業の採用情報が技術用語に偏り、働く人の姿やチームの魅力が伝わりにくかった。',
  challenge: '技術企業の採用を、人とチームの物語として候補者に届けること。',
  insight: '「共に成長しよう」「今の想像は今を超えて創造できる」——技術の裏にある「人とチームの成長」こそが、共感の起点になる。',
  strategy: '「共に成長しよう」を採用メッセージに据え、エンジニア・コンサルタントなど職種別に人とチームの物語を軸にした採用体験を設計。社員紹介、スペシャルコンテンツ、会社紹介動画で組織の魅力を可視化。',
  experience: '職種別コンテンツ、チームの物語、応募導線までを一貫した体験として構築。',
  output: 'Brand Concept / Web / UX/UI / Content / Communication',
  impact: '候補者の理解と共感を高め、採用ブランドを強化。',
  images: [
    {
      src: '/assets/migrated/7942e30dace59c1d1157.webp',
      caption: 'ヒーローデザイン案 — 青い光のトンネル「もっともっと未来にチャレンジを」',
    },
    {
      src: '/assets/migrated/6f5e15d0a3ffd76c0784.webp',
      caption: 'ヒーローデザイン案 — 都市空間とデジタルアイコン「今の想像は今を超えて創造できる」',
    },
    {
      src: '/assets/migrated/09fe4167604b4ca49bc3.webp',
      caption: 'TOPページ全体 — ヒーローから企業情報・メンバー・スペシャルコンテンツ・リクルートまで',
      large: true,
    },
    {
      src: '/assets/migrated/707331ab6441636e2cb2.webp',
      caption: 'リクルートサイト全体像 — TOP・企業情報・メンバー・リクルートの4画面俯瞰',
      large: true,
    },
    {
      src: '/assets/migrated/f254448f6db72170bac3.webp',
      caption: '社員紹介セクション — メンバーカルーセル（金融・産業・流通システム事業部）',
    },
    {
      src: '/assets/migrated/b8c5842b3f79f947bb1b.webp',
      caption: '社員紹介一覧 — 9人の社員メッセージページ',
    },
    {
      src: '/assets/migrated/ea81b4c6851fbb59e642.webp',
      caption: '企業情報ページ — 会社概要・事業内容・数字で知る・教育研修・制度紹介・会社紹介動画',
    },
    {
      src: '/assets/migrated/5dff6e6288cb97cbc0d1.webp',
      caption: '採用サイトデザインC案/D案 + サイトマップ案 — デザインコンセプトコピー案と情報設計',
    },
    {
      src: '/assets/migrated/52dc5a803743bf3c10b3.webp',
      caption: '提案プラン — HITACHI Inspire the Next',
    },
  ],
};

export default hitachiSolutionsCase;